import { useContext } from "react";
import { VisibleLayoutContext } from "./VisibleLayoutContext";
/**
 * Get visible layout
 * - uses {@linkcode VisibleLayoutContext}
 * @returns
 */
export function useVisibleLayout() {
    return useContext(VisibleLayoutContext);
}
//# sourceMappingURL=useVisibleLayout.js.map